/* Pigment shared theme runtime.
   Loaded once via <script defer> in layout/theme.liquid before
   content_for_header, so the section/snippet bundles (which are also
   defer-loaded) execute after this file and can rely on window.pigment.* */
(function () {
  'use strict';
  var ns = (window.pigment = window.pigment || {});

  /* ----- Cart store: coalesced fetch + pub/sub ----------------------- */
  (function () {
    var subs = new Set();
    var pending = null;
    var cached = null;
    var lastFetch = 0;
    var COALESCE_MS = 80;

    function fire(data) {
      subs.forEach(function (fn) {
        try {
          fn(data);
        } catch (e) {
          /* swallow per-subscriber */
        }
      });
    }

    function get(force) {
      var now = performance && performance.now ? performance.now() : Date.now();
      if (!force && pending) return pending;
      if (!force && cached && now - lastFetch < COALESCE_MS) {
        return Promise.resolve(cached);
      }
      pending = fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('cart fetch failed: ' + r.status);
          return r.json();
        })
        .then(function (data) {
          cached = data;
          lastFetch = performance && performance.now ? performance.now() : Date.now();
          pending = null;
          fire(data);
          return data;
        })
        .catch(function (err) {
          pending = null;
          throw err;
        });
      return pending;
    }

    ns.cart = {
      get: function (force) {
        return get(!!force);
      },
      cached: function () {
        return cached;
      },
      set: function (data) {
        cached = data;
        lastFetch = performance && performance.now ? performance.now() : Date.now();
        fire(data);
      },
      subscribe: function (fn) {
        subs.add(fn);
        if (cached) {
          try {
            fn(cached);
          } catch (e) {}
        }
        return function () {
          subs.delete(fn);
        };
      },
      refresh: function () {
        return get(true);
      },
    };

    document.addEventListener('cart:updated', function (e) {
      if (e && e.detail && e.detail.cart) ns.cart.set(e.detail.cart);
      else get(true);
    });
  })();

  /* ----- Product cache: coalesces /products/{handle}.js -------------- */
  (function () {
    var cache = new Map();
    ns.getProduct = function (handle) {
      if (!handle) return Promise.reject(new Error('handle required'));
      if (cache.has(handle)) return cache.get(handle);
      var p = fetch('/products/' + handle + '.js', {
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          if (!r.ok) throw new Error('product fetch failed: ' + r.status);
          return r.json();
        })
        .catch(function (err) {
          /* Evict on failure. Caching the rejected promise would fail this
             handle for the rest of the session after a single blip. */
          cache.delete(handle);
          throw err;
        });
      cache.set(handle, p);
      return p;
    };
  })();

  /* ----- Money formatter via Intl.NumberFormat ----------------------- */
  (function () {
    var fmt;
    function get() {
      if (fmt) return fmt;
      var currency = 'GBP';
      var locale = 'en-GB';
      try {
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
          currency = window.Shopify.currency.active;
        }
        if (window.Shopify && window.Shopify.locale) locale = window.Shopify.locale;
        else if (document.documentElement.lang) locale = document.documentElement.lang;
      } catch (e) {}
      try {
        fmt = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'narrowSymbol',
        });
      } catch (e) {
        fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
      }
      return fmt;
    }
    ns.formatMoney = function (cents) {
      var n = Number(cents) || 0;
      return get().format(n / 100);
    };
  })();

  /* ----- Document visibility registry -------------------------------- */
  (function () {
    var handlers = new Set();
    document.addEventListener('visibilitychange', function () {
      handlers.forEach(function (fn) {
        try {
          fn(document.hidden);
        } catch (e) {}
      });
    });
    ns.onVisibility = function (fn) {
      handlers.add(fn);
      return function () {
        handlers.delete(fn);
      };
    };
    ns.isHidden = function () {
      return document.hidden;
    };
  })();

  /* ----- Load-on-interaction helper ---------------------------------- */
  (function () {
    var INTERACTION = ['pointerdown', 'keydown', 'focusin', 'touchstart'];
    ns.onFirstInteraction = function (target, fn, events) {
      var evs = events || INTERACTION;
      var fired = false;
      function run(e) {
        if (fired) return;
        fired = true;
        evs.forEach(function (ev) {
          target.removeEventListener(ev, run, true);
        });
        try {
          fn(e);
        } catch (err) {
          console.error(err);
        }
      }
      evs.forEach(function (ev) {
        target.addEventListener(ev, run, { capture: true, passive: true });
      });
    };
  })();

  /* ----- Tiny event bus for cross-bundle messages -------------------- */
  (function () {
    var bus = new EventTarget();
    ns.bus = {
      on: function (type, fn) {
        bus.addEventListener(type, fn);
        return function () {
          bus.removeEventListener(type, fn);
        };
      },
      off: function (type, fn) {
        bus.removeEventListener(type, fn);
      },
      emit: function (type, detail) {
        bus.dispatchEvent(new CustomEvent(type, { detail: detail }));
      },
    };
  })();

  /* ----- Image protection: block contextmenu + drag on <img> --------- */
  (function () {
    function isImage(target) {
      if (!target || !target.closest) return false;
      return !!target.closest('img, picture');
    }
    document.addEventListener('contextmenu', function (e) {
      if (isImage(e.target)) e.preventDefault();
    });
    document.addEventListener('dragstart', function (e) {
      if (isImage(e.target)) e.preventDefault();
    });
  })();

  /* ----- Section re-init registry ------------------------------------
     The theme editor replaces a section's DOM and fires
     shopify:section:load. Section and snippet {% javascript %} bundles
     are concatenated into one asset that runs once per page load, so
     everything bound on that first run is left pointing at removed
     nodes. Register an initialiser here and it runs immediately, then
     again every time the editor renders a section.

     An initialiser is handed the document on first run and, after that,
     the section element that was just rendered. Query inside that root
     rather than the document, and keep the data-*-bound guards so a
     repeat call over the same element is a no-op. */
  (function () {
    var inits = [];
    function run(fn, root) {
      try {
        fn(root);
      } catch (e) {
        console.error(e);
      }
    }
    ns.onSectionRender = function (fn) {
      if (typeof fn !== 'function') return;
      inits.push(fn);
      run(fn, document);
    };
    document.addEventListener('shopify:section:load', function (e) {
      /* Scope re-init to the section that was just rendered. Its elements are
         brand new, so binding them cannot double-bind anything that survived
         elsewhere on the page. */
      var root = (e && e.target) || document;
      inits.forEach(function (fn) {
        run(fn, root);
      });
    });
  })();

  /* ----- DOMContentLoaded promise ------------------------------------ */
  ns.ready = new Promise(function (resolve) {
    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          resolve();
        },
        { once: true },
      );
    } else {
      resolve();
    }
  });
})();
